module.exports = __webpack_public_path__ + "img/pt-20.bf091fdf.jpg";